import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./employerPortal.css";

export default function AddCompany() {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine if current path is for institution
  const isInstitution = location.pathname.includes("institution");

  const [company, setCompany] = useState({
    companyName: "",
    registrationNumber: "",
    phoneNo1: "",
    email: "",
    website: "",
    businessTypeId: "",
    companyLogo: null, // Add logo field
  });

  const [businessTypes, setBusinessTypes] = useState([]);

  useEffect(() => {
    const fetchBusinessTypes = async () => {
      try {
        const response = await AxiosInstance.get(
          "companies/business/"
        );
        setBusinessTypes(response.data);
      } catch (error) {
        console.error("Error fetching business types:", error);
      }
    };

    fetchBusinessTypes();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "companyLogo") {
      setCompany((prev) => ({
        ...prev,
        companyLogo: files[0], // File object
      }));
    } else {
      setCompany((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userId = localStorage.getItem("userId");

    if (!userId) {
      alert("User is not logged in.");
      return;
    }

    const formData = new FormData();
    formData.append("user", userId);
    formData.append("company_name", company.companyName);
    formData.append("registration_number", company.registrationNumber);
    formData.append("phone_no_1", company.phoneNo1);
    formData.append("email", company.email);
    formData.append("website", company.website);
    formData.append("business_type", company.businessTypeId);

    if (company.companyLogo) {
      formData.append("company_logo", company.companyLogo);
    }

    try {
      await AxiosInstance.post(
        "companies/company/creation/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert(
        `${isInstitution ? "Institution" : "Company"} created successfully!`
      );
      navigate(isInstitution ? "/institution-details" : "/company-details");
    } catch (error) {
      console.error(
        `Error creating ${isInstitution ? "institution" : "company"}:`,
        error
      );
      alert(`Failed to create ${isInstitution ? "institution" : "company"}.`);
    }
  };

  const closeModal = () => {
    navigate(isInstitution ? "/institution-details" : "/company-details");
  };

  return (
    <>
      {/* Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal */}
      <div
        className="modal d-block als-employer-page"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="addCompanyLabel"
        style={{ backgroundColor: "rgba(11,14,39,0.45)" }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addCompanyLabel">
                Add {isInstitution ? "Institution" : "Company"}
              </h5>
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">
                    {isInstitution ? "Institution" : "Company"} Name
                  </label>
                  <input
                    type="text"
                    name="companyName"
                    className="form-control"
                    value={company.companyName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Registration Number</label>
                  <input
                    type="number"
                    name="registrationNumber"
                    className="form-control"
                    value={company.registrationNumber}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="text"
                    name="phoneNo1"
                    className="form-control"
                    value={company.phoneNo1}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={company.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Website</label>
                  <input
                    type="text"
                    name="website"
                    className="form-control"
                    value={company.website}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Business Type</label>
                  <select
                    name="businessTypeId"
                    className="form-select"
                    value={company.businessTypeId}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Business Type</option>
                    {businessTypes.map((type) => (
                      <option
                        key={type.business_type_id}
                        value={type.business_type_id}
                      >
                        {type.business_type}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Logo</label>
                  <input
                    type="file"
                    name="companyLogo"
                    className="form-control"
                    accept="image/*"
                    onChange={handleChange}
                  />
                </div>

                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save {isInstitution ? "Institution" : "Company"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
